import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Star, Trophy, Users, ShieldCheck } from "lucide-react";
import api from "../lib/api";

export default function About() {
  const [settings, setSettings] = useState(null);
  useEffect(() => { api.get("/settings/public").then((r) => setSettings(r.data)).catch(() => {}); }, []);
  const name = settings?.business_name || "DreamCots";

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-8 py-14">
      <p className="nb-label" style={{ letterSpacing: "0.2em" }}>About Us</p>
      <h1 data-testid="about-heading" className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight mt-2">About {name}</h1>
      <p className="mt-6 text-slate-600 leading-relaxed">
        {name} is a hyper-local education directory that helps students and parents discover the best
        coaching institutes and schools in their own area and city. Unlike generic national lists, our rankings
        are earned — powered by real student reviews on teacher quality, classroom environment and teaching
        methods, plus actual admissions secured by each institution.
      </p>
      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-6">
        {[
          { icon: Star, bg: "#FCD34D", title: "Honest reviews", desc: "Every review is aspect-wise and comes from a mobile-verified student account." },
          { icon: Trophy, bg: "#A3E635", title: "Fair rankings", desc: "A transparent points system decides who ranks #1 in each area — no pay-to-win rankings." },
          { icon: Users, bg: "#93C5FD", title: "Direct connection", desc: "Students follow institutes, get exam alerts and apply through direct application links." },
          { icon: ShieldCheck, bg: "#FDBA74", title: "Verified listings", desc: "Featured and Verified badges help you spot trusted institutions instantly." },
        ].map(({ icon: Icon, bg, title, desc }) => (
          <div key={title} className="nb p-6" style={{ background: bg }}>
            <span className="w-11 h-11 rounded-xl border-2 border-[#171B33] bg-white flex items-center justify-center"><Icon className="w-5 h-5" /></span>
            <p className="font-display font-extrabold mt-4">{title}</p>
            <p className="text-sm mt-1 opacity-80">{desc}</p>
          </div>
        ))}
      </div>
      <div className="nb mt-10 p-8" style={{ background: "#171B33" }}>
        <h2 className="font-display text-2xl font-extrabold text-white">Run an institute or school?</h2>
        <p className="text-slate-300 text-sm mt-2">List on {name} for free and start earning ranking points today.</p>
        <Link to="/register" data-testid="about-cta-btn" className="nb-btn nb-btn-lime mt-6">List your institute</Link>
      </div>
    </div>
  );
}
